export default "__VITE_ASSET__de110242__"